/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-08-05 17:07:37
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-02-18 16:46:05
 * @Description: file content
 */
// 定义state
const state = {
  info: {},
  channel: "",
  addList: [],
  isShowGuide: undefined,//是否显示引导
  isLoading: undefined,//是否显示loading
  isInMiniProgram: undefined,//是否是在小程序的webview中
  receiveSpreadInfo: null,//接收到的传播信息
  shareSpreadInfo: null,//分享传播信息
  pageInfo: null,//如是创建H5和神奇包裹的页面信息
  cardInfo: null,//小程序名片信息，通过/open/findUserByUnionid获取
  userInfo: null,//如是用户信息
  hdkUserInfo: null,//如是用户对应的很多客用户信息，通过/open/findUserByUnionid获取
  sourceGzhInfo: null,//很多宝 公众号信息卡片
  isShowMyCard: false,//是否隐藏名片。切换名片展示和操作按钮展示。初始值从接口获取。
  rsCardInfo: null,//如是rscuid获取的信息
};
// 传出state
export default state;
